
import { defineComponent } from 'vue';

const __default__ = defineComponent({
    /*各ボタン */
    name: 'BasicButton',
    props: {
        width: {
            type: Number,
            default: 182,
        },
        buttonType: {
            type: String,
            default: 'primary',
        },
        isRedButton: {
            type: Boolean,
            default: false,
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
        fontWeight: {
            type: String,
            default: 'bold',
        },
    },
    emits: ['click'],
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "032b4b4d": (_ctx.fontWeight)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__